import { defineCustomElement } from '@tyler-components-web/core';
import { FloatingActionButton } from './floating-action-button';
export * from './floating-action-button-constants';
export * from './floating-action-button';
export function defineFloatingActionButtonComponent() {
    defineCustomElement(FloatingActionButton);
}
